<template>
	<div class="CustomBlockWidth " > 
		<div class="card ">
		  <div class="card-body text-center">
			<img src="../../../../static/fxView/images/lost.svg" alt="no account found" class="mb-4" width="200">  
			<!-- Text -->
			<span v-if="demo_live_both == 'yes'">
				<p class="text-muted mb-3" >
				  {{$t('noTradAccMsz41')}}
				</p> 
				<div class="button-group-row">
					<router-link to="/create-live-account" class="prism_btn btn_sm lift">
						{{$t('createLiveAccount')}}
					  </router-link>
					  <router-link to="/create-demo-account" class="prism_btn btn_sm lift">
							{{$t('createDemoAccount')}}
					  </router-link>
				</div>
			</span>
			<span v-else>
				<span v-if="get_user.step > 4">
					<p class="text-muted mb-3" >
					  {{$t('noTradAccMsz1')}}
					</p> 
					<router-link to="/create-live-account" class="prism_btn btn_sm lift">
					  {{$t('createLiveAccount')}}
					</router-link>
				</span>
				
				<span v-else-if="get_user.step > 2 && get_user.profile.total_points < 6">
					<p class="text-muted mb-3" >{{$t('noTradAccMsz2')}}</p>

					<p class="text-muted mb-3" >{{$t('noTradAccMsz3')}}</p> 
					<router-link to="/create-demo-account" class="prism_btn btn_sm lift">
					  {{$t('createDemoAccount')}}
					</router-link>
				</span>
				
				<span v-else>
					<p class="text-muted mb-3">{{$t('noTradAccMsz4')}}</p>
					<router-link to="/index" class="prism_btn btn_sm lift">{{$t('resumeApplication')}}</router-link>
				</span>
			</span>
		  </div>
		</div>
	</div>
</template>
<script>
    import { fxViewMixins } from '@/plugins/fxView'
    export default {
        name: 'Deposit',
        mixins: [fxViewMixins],
        data() {
            return {
            	
            }
        },
		props:['demo_live_both']
    }
</script>


// WEBPACK FOOTER //
// src/components/fxView/shared/no_trading_account.vue